module.exports = __webpack_public_path__ + "img/login-bg.4b0bf1ad.png";